import { render, staticRenderFns } from "./WarnAdd.vue?vue&type=template&id=95190352&scoped=true"
import script from "./WarnAdd.vue?vue&type=script&lang=js"
export * from "./WarnAdd.vue?vue&type=script&lang=js"
import style0 from "./WarnAdd.vue?vue&type=style&index=0&id=95190352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95190352",
  null
  
)

export default component.exports